var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"main-panel-composer main-panel-tab",attrs:{"id":"main-composer"}},[_c('iframe',{attrs:{"id":"composer-frame","src":"/composerframe.html","width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }